import { buildClinicPrintDocumentHtml } from './clinicPrintLetterhead';
import { buildEvolutionTextDocBodyHtml } from './evolutionTextDocPrintDocument';
import { isSignedMedicalReport } from './medicalReportSignature';

export function buildMedicalReportPrintHtml(printData: any): string {
  const report = printData?.report || {};
  const clinic = printData?.clinic || {};
  const patient = report.patient || report.patient_snapshot || {};
  const professional = report.professional || report.professional_snapshot || {};

  const displayTitle = String(report.title || '').trim() || 'Relatório médico';

  const bodyHtml = buildEvolutionTextDocBodyHtml({
    category: 'report',
    omitDocumentHeading: true,
    omitTemplateName: true,
    templateName: displayTitle,
    bodyText: report.body_text || '',
    patient: {
      full_name: patient.full_name || report.patient_name,
      cpf: patient.cpf || report.patient_cpf,
      birth_date: patient.birth_date,
      gender: patient.gender,
    },
    professional: {
      full_name: professional.full_name || report.professional_name,
      specialty: professional.specialty,
      registration_type: professional.registration_type || report.professional_registration_type,
      registration_number: professional.registration_number || report.professional_registration,
      registration_state: professional.registration_state || report.professional_registration_state,
      signature_image_url: professional.signature_image_url,
      professional_credentials: professional.professional_credentials,
    },
    issueDate: report.issue_date || report.created_at,
  });

  const signedStamp = isSignedMedicalReport(report) && report.signer_name
    ? `<div style="margin-top:24px;padding:12px 14px;border:1px solid #99f6e4;border-left:4px solid #0d9488;border-radius:6px;background:#f0fdfa;">
        <div style="font-size:10px;font-weight:700;color:#0f766e;text-transform:uppercase;letter-spacing:0.6px;margin-bottom:6px;">Documento assinado digitalmente</div>
        <div style="font-size:12px;font-weight:700;color:#111827;">${String(report.signer_name)}</div>
        ${report.signature_verification_code ? `<div style="font-size:10px;color:#374151;margin-top:6px;">Código de conferência: <strong>${report.signature_verification_code}</strong></div>` : ''}
      </div>`
    : '';

  const extra = report.diagnosis_code || report.diagnosis
    ? `<div style="margin:0 0 12px;font-size:11px;"><strong>CID:</strong> ${report.diagnosis_code || ''}${report.diagnosis ? ` — ${report.diagnosis}` : ''}</div>`
    : '';

  return buildClinicPrintDocumentHtml({
    clinic,
    browserTitle: displayTitle,
    bodyHtml: `${extra}${bodyHtml}${signedStamp}`,
  });
}
